import { render, staticRenderFns } from "./ReceiptTemplatesList.vue?vue&type=template&id=1db8c36b&scoped=true&"
import script from "./ReceiptTemplatesList.vue?vue&type=script&lang=js&"
export * from "./ReceiptTemplatesList.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptTemplatesList.vue?vue&type=style&index=0&id=1db8c36b&lang=scss&scoped=true&"
import style1 from "./ReceiptTemplatesList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db8c36b",
  null
  
)

export default component.exports